/**
 * Application timezone — all user-visible dates/times, calendars, and date pickers
 * must use this zone (Asia/Kolkata / IST). Pair with server `process.env.TZ` and
 * MySQL `time_zone = +05:30` for consistency.
 */
export const APP_TIMEZONE = 'Asia/Kolkata';
export const APP_LOCALE = 'en-IN';
